/* Mobile Footer menu drop downs */
const toggler = document.querySelectorAll('.footer-top .toggler');
if (toggler.length) {
  toggler.forEach(toggleEl => {
    toggleEl.addEventListener('click', function () {
      toggleEl.classList.toggle('active');
      const toggle = toggleEl.nextElementSibling;
      if (toggle.classList.contains('toggle')) {
        toggle.classList.toggle('active');
      }
      // Toggle aria-expanded
      const expanded = toggleEl.classList.contains('active');
      toggleEl.setAttribute('aria-expanded', expanded);
    });
  });
}

/* Product Page Accordions */
let accordions = document.querySelectorAll('.accordion');
if (accordions.length) {
  accordions.forEach(accordion => {
    accordion.addEventListener('click', () => {
      accordion.classList.toggle('active');
      const panel = accordion.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
      // Toggle aria-expanded
      const expanded = accordion.classList.contains('active');
      accordion.setAttribute('aria-expanded', expanded);
    });

    if (accordion.classList.contains('active')) {
      const panel = accordion.nextElementSibling;
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });
}
